// Import Core
import React, { useContext, useEffect, useState } from "react";
import { graphql } from "gatsby";
// Import Libraries
import { Breadcrumb } from "gatsby-plugin-breadcrumb";
import { PortableText } from "@portabletext/react";
// Import Components
import SEO from "../components/SEO";
import PillarHero from "../components/blocks/Hero/PillarHero";
import ResultCards from "../components/blocks/Cards/ResultCards";
import PageContent from "../components/base/PageContent";
import { Button } from "../components/ui/Button";
import PortableTextComponent from "../components/ui/PortableTextComponent";
import SlideInMap from "../components/ui/SlideInMap";
import SectionTitle from "../components/ui/SectionTitle";
import RenderAdditionalCollectionBlocks from "../components/logicBlocks/RenderAdditionalCollectionBlocks";
// Import Icons
import { FaAngleRight, FaList, FaMap } from "react-icons/fa";
// Import Utils
import { toSentenceCase } from "../utils/toSentenceCase";
// Import Logic
import { getNearbyHotels } from "../utils/logic/getNearbyHotels";
import { getHotelsBySearchTags } from "../utils/logic/getHotelsBySearchTags";
import getSpecialOffersForHotels from "../utils/logic/getSpecialOfferForHotel";
// Import Queries (Context)
import RootContext from "../context/RootContext";
import { getPillarResults } from "../utils/logic/getPillarResults";
import { getHotelsFeaturedOnPage } from "../utils/logic/getHotelsFeaturedOnPage";
import { orderByDistance } from "geolib";
import { getHotelsOrPagesFromIds } from "../utils/logic/getHotelsOrPagesFromIds";
import SponsorAdBanner from "../components/blocks/SponsorAdBanner";
import { getSlug } from "../utils/getSlug";
// Import Lazy Loading Components
// const PageContent = lazy(() => import('../components/base/PageContent'));
// const ResultCards  = lazy(() => import('../components/blocks/Cards/ResultCards'));
// const PortableTextComponent  = lazy(() => import('../components/ui/PortableTextComponent'));
// const SlideInMap  = lazy(() => import('../components/ui/SlideInMap'));
// const SectionTitle  = lazy(() => import('../components/ui/SectionTitle'));
// const RenderAdditionalCollectionBlocks  = lazy(() => import('../components/logicBlocks/RenderAdditionalCollectionBlocks'));

/* Functions */
// const getHotelsFeaturedOnPage = (specialOfferHotelResults, mainBlockHotelResults, setHotelIdsFeaturedOnPage) => {
// 	// We will add specialOfferHotelResults & mainBlockHotelResults to a list of hotel ids featured on the page - then when there is pageContent it will compare to make sure no duplicate hotels are added
// 	let specialOfferHotelIds = [], mainBlockHotelIds = [];

// 	if(specialOfferHotelIds.length !== specialOfferHotelResults.length) {
// 		specialOfferHotelIds = specialOfferHotelResults.length > 0 ? specialOfferHotelResults.map(offer => offer._id) : []
// 	}
// 	if(mainBlockHotelIds.length !== mainBlockHotelResults.length) {
// 		mainBlockHotelIds = mainBlockHotelResults.length > 0 ? mainBlockHotelResults.map(offer => offer._id) : []
// 	}

// 	if(specialOfferHotelIds.length > 0  || mainBlockHotelIds.length > 0) {
// 		const combinedResults = specialOfferHotelIds.concat(mainBlockHotelIds)
// 		setHotelIdsFeaturedOnPage(combinedResults)
// 	}

// }

/* Components */
// -> ⚠️ MAIN LOOP!
// This is the main content on pillar pages - editorsChoice is all manual selections, all other types display the logic - special offers then non-special offers
const MainPillarContent = ({
  specialOffers,
  allHotels,
  allPillarPages,
  pillar,
  specialOfferHotelResults,
  mainBlockHotelResults,
  isMapOpen,
  toggleMap,
  placeholderImage,
  sponsorsAdBanners,
}) => {
  const { goldOffers, silverOffers, internationalOffers } =
    getSpecialOffersForHotels(allHotels, specialOffers);

  // Map coordinates
  let filterByLocation, mapSearchRadius;
  if (pillar.mapSearchOptions) {
    filterByLocation = pillar.mapSearchOptions.filterByLocation;
    mapSearchRadius = pillar.mapSearchOptions.mapSearchRadius;
  }

  // All filtered hotel arrays will go in here
  let allFilteredHotels = [];

  // -> 🧠 LET'S GET SOME LOGIC HERE!!!!
  // This tells us which way to get hotels
  const typeOfPillarFilter = pillar.pillarFilterOptions;

  /**
   * -> Three types of filtering options for a page
   * 1. Search Tags,
   * 2. Map Coordinates or
   * 3. Manually Add Hotels
   */

  // const [mainContent, setMainContent] = useState()

  // Get search tags so we can add search tag summaries if any exist for the tag and get first one
  // NOTE: If Editor's Choice page has a block specific tag it will override this one -> specificPillarSummaryTag
  const pillarSummaryTag =
    pillar.hotelSearchTags && pillar.hotelSearchTags.filterByTags.length > 0
      ? pillar.hotelSearchTags.filterByTags
      : null;

  let sectionTitle;
  // If Editor's Choice Page there may be additional search tags within each section
  // let specificPillarSummaryTag = [];

  // ! FIX:  THESE PAGE TYPES CAN BE SPLIT INTO DIFFERENT TEMPLATES
  // // IF PAGE TYPE EQUALS EDITORS CHOICE
  // if (pillar.pillarPageOptions.pageType === 'editorsChoice') {
  // 	let editorsChoiceSections = pillar.editorsChoiceSection.editorsChoiceSection;

  // 	// Loop through & get all hotels from each section so we can add to map
  // 	const hotelsToDisplayOnMap = editorsChoiceSections.map((section) => {
  // 		allFilteredHotels = section.editorsSelectedHotels.map((hotel) => hotel._id);
  // 		const filteredHotelResults = getHotelsOrPagesFromIds(allHotels, allFilteredHotels);
  // 		// Filter out any hotels that have no location as it can't be included in the map
  // 		return filteredHotelResults.filter(hotel => hotel.location && hotel.location.lat)
  // 	}).flat()
  // 	const mapHotelSelection = [...new Set(hotelsToDisplayOnMap)]

  // 	const renderEditorsChoiceSections = () => {
  // 		// Loop through and get hotel ids and change object to array with id value
  // 		return editorsChoiceSections.map((section, index) => {

  // 			// Check if there are specific summary tags for the section
  // 			if(section.hotelSearchTags && section.hotelSearchTags.filterByTags && section.hotelSearchTags.filterByTags.length > 0) {
  // 				specificPillarSummaryTag = section.hotelSearchTags.filterByTags
  // 				// console.log(section.hotelSearchTags.filterByTags, section.title, index)
  // 			}

  // 			allFilteredHotels = section.editorsSelectedHotels.map(
  // 				(hotel) => hotel._id
  // 			);

  // 			const filteredHotelResults = getHotelsOrPagesFromIds(
  // 				allHotels,
  // 				allFilteredHotels
  // 			);

  // 			// Sort hotels into ranks
  // 			let hotelResults = getHotelRanks(filteredHotelResults);

  // 			// -> SPECIAL OFFERS
  // 			// Then
  // 			specialOfferHotelResults = getHotelSpecialOffers(
  // 				hotelResults,
  // 				goldOffers,
  // 				silverOffers,
  // 				internationalOffers
  // 			);

  // 			mainBlockHotelResults = getMainBlockHotels(
  // 				hotelResults,
  // 				specialOfferHotelResults
  // 			);

  // 			hotelResults = specialOfferHotelResults.concat(mainBlockHotelResults);

  // 			sectionTitle = {
  // 				subtitle: section.subheading ? section.subheading : false,
  // 				title: section.title,
  // 				caption: section.caption ? section.caption : false,
  // 				button: (index === 0 && mapHotelSelection.length > 0) && <Button onClick={toggleMap} role='button' className='slide-in-map-button'>
  // 				{isMapOpen ? 'Close Map' : 'Map' }
  // 				<span>{isMapOpen ? <FaList /> : <FaMap /> }</span>
  // 			</Button>
  // 			}

  // 			return (
  // 				<section key={index}>
  // 					{/* Return all results within each editor's choice section */}
  // 					{(hotelResults.length > 0 && (
  // 						<ResultCards
  // 							key={section.title}
  // 							hotels={hotelResults}
  // 							pillarSummaryTag={specificPillarSummaryTag.length > 0 ? specificPillarSummaryTag : pillarSummaryTag}
  // 							sectionTitle={sectionTitle}
  // 							className='result-cards'
  // 							placeholderImage={placeholderImage}
  // 						/>
  // 					)) ||
  // 						null}
  // 				</section>
  // 			);
  // 		});
  // 	}

  // 	return (
  // 		<div id='map-wrapper' className={isMapOpen ? 'slide' : ''}>
  // 			{mapHotelSelection.length > 0 &&
  // 				<SlideInMap hotels={mapHotelSelection} placeholderImage={placeholderImage} />
  // 			}
  // 			<div className='results-container'>
  // 				{renderEditorsChoiceSections()}
  // 			</div>
  // 		</div>
  // 	)
  // }

  // IF PAGE TYPE EQUALS PILLAR COLLECTION
  // else
  // if (pillar.pillarPageOptions.pageType === 'pillarCollection') {
  // 	let pillarCollectionSections = pillar.pillarCollectionSection.pillarCollectionSection;

  // 	const renderPillarCollectionSections = () => {
  // 		// Loop through and get hotel ids and change object to array with id value
  // 		return pillarCollectionSections.map((section, index) => {
  // 			allFilteredHotels = section.pageTypePillarCollectionSelectedPages.map(
  // 				(hotel) => hotel._id
  // 			);

  // 			const hotelResults = getHotelsOrPagesFromIds(
  // 				allPillarPages,
  // 				allFilteredHotels
  // 			);

  // 			sectionTitle = {
  // 				subtitle: section.subheading ? section.subheading : false,
  // 				title: section.title,
  // 				caption: section.sectionText ? section : false,
  // 			}

  // 			return hotelResults.length > 0 ?
  // 			(
  // 				<AdditionalCards
  // 					key={index}
  // 					cardsType='collectionDefault'
  // 					resultsType={pillar}
  // 					allPages={hotelResults}
  // 					sectionTitle={sectionTitle}
  // 					pagesToShow={8}
  // 					id={`anchor_${sectionTitle.title}`}
  // 					className='anchor-link'
  // 					placeholderImage={placeholderImage}
  // 				/>
  // 			) : null
  // 		});
  // 	}

  // 	return (
  // 		<div className="pillar-collection-pages">
  // 			{renderPillarCollectionSections()}
  // 		</div>
  // 	)
  // }

  // else {
  // Loop through all hotels to see if each hotel matches each filter criteria and place in respective arrays
  if (typeOfPillarFilter === "useSearchTags") {
    allFilteredHotels = getHotelsBySearchTags(allHotels, pillar);
  }

  if (typeOfPillarFilter === "useMapCoordinates") {
    if (filterByLocation) {
      allFilteredHotels = getNearbyHotels(
        allHotels,
        filterByLocation,
        mapSearchRadius
      ).slice(0, 10);
    } else {
      allFilteredHotels = [];
    }
  }

  if (typeOfPillarFilter === "useManualHotels") {
    // An easy one as the hotel ids are in this object item, we just need to change object to array with id value
    allFilteredHotels = pillar.manuallySelectedHotels.map((hotel) => hotel._id);
  }

  // const filteredHotelResults = getHotelsOrPagesFromIds(allHotels, allFilteredHotels);

  // // -> PHEW! 😅 We're getting there!

  // // Sort hotels into ranks
  // let hotelResults = getHotelRanks(filteredHotelResults);

  // // -> SPECIAL OFFERS
  // // Then
  // specialOfferHotelResults = getHotelSpecialOffers(
  // 	hotelResults,
  // 	goldOffers,
  // 	silverOffers,
  // 	internationalOffers
  // ).slice(0, 30);

  // mainBlockHotelResults = getMainBlockHotels(
  // 	hotelResults,
  // 	specialOfferHotelResults
  // ).slice(0, 30);

  // THIS IS SAME ON PILLAR
  let pillarResults = getPillarResults(
    allHotels,
    specialOffers,
    allFilteredHotels,
    mainBlockHotelResults,
    specialOfferHotelResults
  );

  let hotelResults = pillarResults.hotelResults;

  //   mainBlockHotelResults = pillarResults.mainBlockHotelResults.slice(0, 30);
  mainBlockHotelResults = pillarResults.mainBlockHotelResults;
  specialOfferHotelResults = pillarResults.specialOfferHotelResults.slice(
    0,
    30
  );

  // If pillar Page is tourist Attraction - order
  if (
    pillar.pillarPageOptions.pageType === "touristAttraction" &&
    filterByLocation
  ) {
    const getFlattenedLocationObject = (hotel) => {
      const locationFilteredHotels = [];
      hotel.forEach((hotel) => {
        locationFilteredHotels.push({
          lat: hotel.location.lat,
          lng: hotel.location.lng,
          id: hotel._id,
        });
      });
      return locationFilteredHotels;
    };

    // orderByDistance (geolib) to get hotels in ascending order of distance (closest is first)
    const orderedMainLocationsByDistance = orderByDistance(
      filterByLocation,
      getFlattenedLocationObject(mainBlockHotelResults)
    );
    // Save all hotel Ids into our allFilteredHotels array
    mainBlockHotelResults = orderedMainLocationsByDistance.map(
      (hotel) => hotel.id
    );
    mainBlockHotelResults = getHotelsOrPagesFromIds(
      pillarResults.mainBlockHotelResults,
      mainBlockHotelResults
    );

    const orderedSpecialLocationsByDistance = orderByDistance(
      filterByLocation,
      getFlattenedLocationObject(specialOfferHotelResults)
    );
    // Save all hotel Ids into our allFilteredHotels array
    specialOfferHotelResults = orderedSpecialLocationsByDistance.map(
      (hotel) => hotel.id
    );
    specialOfferHotelResults = getHotelsOrPagesFromIds(
      pillarResults.specialOfferHotelResults,
      specialOfferHotelResults
    );
  }

  // Filter out any hotels that have no location as it can't be included in the map
  const mapHotelSelection = specialOfferHotelResults
    .filter((hotel) => hotel.location && hotel.location.lat)
    .concat(
      mainBlockHotelResults.filter(
        (hotel) => hotel.location && hotel.location.lat
      )
    );

  // If featured Hotels is after Special Offers then show 'More Hotels in $town' or similar depending on page type, otherwise show 'Featured Hotels'

  // featuredSectionTitle = 'Hotels in ' . pillar.hotelSearchOptions.filterByTown'
  let featuredSectionTitle = "";

  // if(pillar.pillarPageOptions.pageType === 'editorsChoice') {
  // 	featuredSectionTitle = pillar.name
  // } else if(pillar.pillarPageOptions.pageType === 'collection') {
  // 	featuredSectionTitle = pillar.name
  // } else
  if (
    pillar.pillarPageOptions.pageType === "collection" ||
    pillar.pillarPageOptions.pageType === "country" ||
    pillar.pillarPageOptions.pageType === "county" ||
    pillar.pillarPageOptions.pageType === "town" ||
    pillar.pillarPageOptions.pageType === "region" ||
    pillar.pillarPageOptions.pageType === "touristAttraction" ||
    pillar.pillarPageOptions.pageType === "theme"
  ) {
    let pillarName = pillar.name;
    featuredSectionTitle = `More ${pillarName}`;
    // If hotel has a number at the beginning e.g., '10 of the best', remove '10' then add 'more'
    for (let i = 0; i <= 100; i += 1) {
      if (pillarName.startsWith(i.toString()))
        featuredSectionTitle = `More ${pillarName.replace(i.toString(), "")}`;
    }
  }

  let collectionSectionTitle = {
    title: pillar.collectionSectionTitle || "Featured Hotels",
    button: mapHotelSelection.length > 0 && (
      <Button onClick={toggleMap} role="button" className="slide-in-map-button">
        {isMapOpen ? "Close Map" : "Map"}
        <span>{isMapOpen ? <FaList /> : <FaMap />}</span>
      </Button>
    ),
  };
  let sectionTitleOffers = {
    // subtitle: 'Good Hotel Guide',
    title: "Featured Hotels with Special Offers",
    button: mapHotelSelection.length > 0 && (
      <Button onClick={toggleMap} role="button" className="slide-in-map-button">
        {isMapOpen ? "Close Map" : "Map"}
        <span>{isMapOpen ? <FaList /> : <FaMap />}</span>
      </Button>
    ),
  };
  sectionTitle = {
    // subtitle: specialOfferHotelResults.length > 0 ? '' : 'Good Hotel Guide',
    title:
      specialOfferHotelResults.length > 0
        ? featuredSectionTitle
        : "Featured Hotels",
    button: specialOfferHotelResults.length <= 0 &&
      mapHotelSelection.length > 0 && (
        <Button
          onClick={toggleMap}
          role="button"
          className="slide-in-map-button"
        >
          {isMapOpen ? "Close Map" : "Map"}
          <span>{isMapOpen ? <FaList /> : <FaMap />}</span>
        </Button>
      ),
  };

  // If page type = 'collection', it is one block of results (special offers and non-special offers) plus additional blocks if added in CMS
  if (pillar.pillarPageOptions.pageType === "collection") {
    // Main Block
    hotelResults = specialOfferHotelResults.concat(mainBlockHotelResults);

    return (
      <div id="map-wrapper" className={isMapOpen ? "slide" : ""}>
        {mapHotelSelection.length > 0 && (
          <SlideInMap
            hotels={mapHotelSelection}
            placeholderImage={placeholderImage}
            isMapOpen={isMapOpen}
            toggleMap={toggleMap}
          />
        )}
        <div className="results-container">
          {(hotelResults.length > 0 && (
            <ResultCards
              key="Featured Hotels with Special Offers"
              hotels={hotelResults}
              sectionTitle={collectionSectionTitle}
              pillarSummaryTag={pillarSummaryTag}
              className="result-cards"
              placeholderImage={placeholderImage}
            />
          )) ||
            null}

          {/* Add first Sponsor Banner if there were hotel results */}
          {hotelResults.length > 0 &&
            sponsorsAdBanners &&
            sponsorsAdBanners.length > 0 && (
              <SponsorAdBanner
                sponsor={sponsorsAdBanners[0]}
                slug={getSlug(pillar)}
              />
            )}

          {/* If there are additional blocks of hotels added to collection page type then show them here */}
          {pillar.pageTypeCollectionSection && (
            <RenderAdditionalCollectionBlocks
              pillar={pillar}
              allFilteredHotels={allFilteredHotels}
              allHotels={allHotels}
              specialOfferHotelResults={specialOfferHotelResults}
              goldOffers={goldOffers}
              silverOffers={silverOffers}
              internationalOffers={internationalOffers}
              mainBlockHotelResults={mainBlockHotelResults}
              pillarSummaryTag={pillarSummaryTag}
              sectionTitle={sectionTitle}
              placeholderImage={placeholderImage}
            />
          )}

          {/* Add Second Sponsor Banner if there are additonal blocks of collections */}
          {pillar.pageTypeCollectionSection &&
            sponsorsAdBanners &&
            sponsorsAdBanners.length > 1 && (
              <SponsorAdBanner
                sponsor={sponsorsAdBanners[1]}
                slug={getSlug(pillar)}
              />
            )}
        </div>
      </div>
    );
  } else {
    // If hotel type is touristAttraction - add distance
    const pillarLocation =
      pillar.pillarPageOptions.pageType === "touristAttraction" &&
      pillar.mapSearchOptions &&
      pillar.mapSearchOptions.filterByLocation
        ? pillar.mapSearchOptions.filterByLocation
        : null;
    const showGridSectionHotels =
      pillar.hotelSearchOptions.filterBySpecialOffers === false ||
      pillar.hotelSearchOptions.filterBySpecialOffers === null ||
      pillar.hotelSearchOptions.filterBySpecialOffers === undefined;
    return (
      <div id="map-wrapper" className={isMapOpen ? "slide" : ""}>
        {mapHotelSelection.length > 0 && (
          <SlideInMap
            hotels={mapHotelSelection}
            placeholderImage={placeholderImage}
            isMapOpen={isMapOpen}
            toggleMap={toggleMap}
          />
        )}

        <div className="results-container">
          {/* If any hotels have special offers */}
          {(specialOfferHotelResults.length > 0 && (
            <ResultCards
              key="Featured Hotels with Special Offers"
              hotels={specialOfferHotelResults}
              sectionTitle={sectionTitleOffers}
              pillarSummaryTag={pillarSummaryTag}
              className="result-cards"
              // If hotel type is touristAttraction - add location to display distance
              pillarLocation={pillarLocation}
              placeholderImage={placeholderImage}
            />
          )) ||
            null}

          {/* Add first Sponsor Banner if there were hotel results */}
          {showGridSectionHotels &&
            specialOfferHotelResults.length > 0 &&
            sponsorsAdBanners &&
            sponsorsAdBanners.length > 0 && (
              <SponsorAdBanner
                sponsor={sponsorsAdBanners[0]}
                slug={getSlug(pillar)}
              />
            )}

          {/* Other results of hotels that don't have special offers
							If there are no special offers display as resultCards otherwise display as Cards */}
          {showGridSectionHotels &&
            ((mainBlockHotelResults.length > 0 &&
              ((specialOfferHotelResults.length <= 0 && (
                <ResultCards
                  key="Featured Hotels"
                  hotels={mainBlockHotelResults}
                  sectionTitle={sectionTitle}
                  pillarSummaryTag={pillarSummaryTag}
                  className="result-cards"
                  // If hotel type is touristAttraction - add location to display distance
                  pillarLocation={pillarLocation}
                  placeholderImage={placeholderImage}
                />
              )) || (
                // <Cards
                // 	cardsType='cardDefault'
                // 	resultsType={pillar}
                // 	allPages={mainBlockHotelResults}
                // 	sectionTitle={sectionTitle}
                // />
                <ResultCards
                  key="Featured Hotels"
                  hotels={mainBlockHotelResults}
                  sectionTitle={sectionTitle}
                  pillarSummaryTag={pillarSummaryTag}
                  className="result-cards-vertical result-cards-pagination"
                  // If hotel type is touristAttraction - add location to display distance
                  pillarLocation={pillarLocation}
                  placeholderImage={placeholderImage}
                  showPagination={true}
                />
              ))) ||
              null)}

          {/* If mainBlockHotelResults then :
								add second Sponsor Banner if there were specialOffer results otherwise show first sponsorBanner */}
          {(mainBlockHotelResults.length > 0 &&
            specialOfferHotelResults.length <= 0 &&
            sponsorsAdBanners &&
            sponsorsAdBanners.length > 0 && (
              <SponsorAdBanner
                sponsor={sponsorsAdBanners[0]}
                slug={getSlug(pillar)}
              />
            )) ||
            (sponsorsAdBanners.length > 1 && (
              <SponsorAdBanner
                sponsor={sponsorsAdBanners[1]}
                slug={getSlug(pillar)}
              />
            ))}

          {/* If there are no results then we just include a paragraph to say no results */}
          {(specialOfferHotelResults.length === 0 &&
            mainBlockHotelResults.length === 0 && (
              <SectionTitle twoCol content="No results available" />
            )) ||
            null}
        </div>
      </div>
    );
  }
};
// };

// !!!!! FIX:  THIS CAN BE SPLIT
// Page Content - each page type can display a selection of page sections
const PageContentByPageType = ({
  pillar,
  hotelIdsFeaturedOnPage,
  placeholderImage,
}) => {
  // Filter out Blog Post Archive Page & Special Offers Page as they will have their own archive pages
  let element = null;
  switch (pillar.pillarPageOptions.pageType) {
    // case 'editorsChoice':
    // case 'pillarCollection':
    case "collection":
      element = pillar.pageContentEditorsAndCollection && (
        <PageContent
          pageContent={pillar.pageContentEditorsAndCollection}
          pillar={pillar}
          hotelIdsFeaturedOnPage={hotelIdsFeaturedOnPage}
          placeholderImage={placeholderImage}
        />
      );
      break;

    case "country":
      element = pillar.pageContentCountry && (
        <PageContent
          pageContent={pillar.pageContentCountry}
          pillar={pillar}
          hotelIdsFeaturedOnPage={hotelIdsFeaturedOnPage}
          placeholderImage={placeholderImage}
        />
      );
      break;

    case "county":
      element = pillar.pageContentCounty && (
        <PageContent
          pageContent={pillar.pageContentCounty}
          pillar={pillar}
          hotelIdsFeaturedOnPage={hotelIdsFeaturedOnPage}
          placeholderImage={placeholderImage}
        />
      );
      break;

    case "town":
      element = pillar.pageContentTown && (
        <PageContent
          pageContent={pillar.pageContentTown}
          pillar={pillar}
          hotelIdsFeaturedOnPage={hotelIdsFeaturedOnPage}
          placeholderImage={placeholderImage}
        />
      );
      break;

    case "region":
      element = pillar.pageContentRegion && (
        <PageContent
          pageContent={pillar.pageContentRegion}
          pillar={pillar}
          hotelIdsFeaturedOnPage={hotelIdsFeaturedOnPage}
          placeholderImage={placeholderImage}
        />
      );
      break;

    case "touristAttraction":
      element = pillar.pageContentTouristAttraction && (
        <PageContent
          pageContent={pillar.pageContentTouristAttraction}
          pillar={pillar}
          hotelIdsFeaturedOnPage={hotelIdsFeaturedOnPage}
          placeholderImage={placeholderImage}
        />
      );
      break;

    case "theme":
      element = pillar.pageContentTheme && (
        <PageContent
          pageContent={pillar.pageContentTheme}
          pillar={pillar}
          hotelIdsFeaturedOnPage={hotelIdsFeaturedOnPage}
          placeholderImage={placeholderImage}
        />
      );
      break;

    default:
      // This is a basic page that has no logic blocks
      element = pillar.pageContentTheme && (
        <PageContent
          pageContent={pillar.pageContentDefault}
          pillar={pillar}
          placeholderImage={placeholderImage}
        />
      );
      break;
  }
  return element;
};

// const getPillarTextContent = (content) => {
// 	// This removes the first sentence from each text block as we need to replace first occurrence later
// 	const pillarTextToChange = content ? (content).map(type => {
// 		if(type._type === 'block' && type.style === 'normal') {
// 			console.log("🚀 ~ file: Pillar.js:434 ~ pillarTextToChange ~ pillarTextToChange", pillarTextToChange);
// 			type.children[0].text = (removeFirstSentence(type.children[0].text).trim())
// 			return type
// 		}
// 	}) : content;

// 	// Find index of first occurence of a pillar hero text block
// 	const PillarContentTextIndex = content ? (content).findIndex(block => block._type === 'block' && block.style === 'normal') : content;
// 	// Save text block with new paragraph (with first sentence removed)
// 	if(content) {
// 		(content)[PillarContentTextIndex] = pillarTextToChange[0];
// 	}

// 	return content
// }

/* Render Page */
const PillarPage = ({
  data,
  pageContext: {
    breadcrumb: { crumbs },
  },
}) => {
  // console.log("🚀 ~ file: Pillar.js:422 ~ PillarPage ~ data:", data);

  // const testdata = useContext(RootContext);
  // console.log("🚀 ~ file: Pillar.js:427 ~ PillarPage ~ testdata:", testdata);

  // const { allPillarPages, allHotels } = useContext(GlobalContext)
  // console.log('tttttttt', data)
  // console.log("🚀 ~ file: Pillar.js:425 ~ PillarPage ~ allPillarPages, allHotels:", allPillarPages, allHotels);
  // console.log("🚀 ~ file: Pillar.js:425 ~ PillarPage ~ test:", test);
  // Cheat to make sure page is loaded - then we render so the correct blocks show!
  const [documentReady, setDocumentReady] = useState(false);
  useEffect(() => {
    setDocumentReady(true);
  }, []);

  // Hooks
  const [hotelIdsFeaturedOnPage, setHotelIdsFeaturedOnPage] = useState([]);
  const [defaultPage, setDefaultPage] = useState({});
  const [isMapOpen, setIsMapOpen] = useState(false);
  // Map
  const toggleMap = () => setIsMapOpen(!isMapOpen);

  // // Anchor Menu for pillarCollection
  // const [anchorLinks, setAnchorLinks] = useState([]);

  // These hold the logic blocks results of a pillar page
  let specialOfferHotelResults = [];
  let mainBlockHotelResults = [];

  // -> CREATE VARIABLES
  const pillar = data.pillar;
  const specialOffers = data.specialOffers.nodes;

  // FIX:
  const { allHotels, allPillarPages } = useContext(RootContext);
  // const pillarPages = data.pillarPages.nodes
  const pillarPages = allPillarPages;
  // const pillarPages = useAllPillar();

  // Get hotels from graphql query
  // let allHotels = useAllHotels();
  // let allHotels = data.allHotels.nodes;

  // If a page has no type then it will be a default page - it will only show content
  useEffect(() => {
    setDefaultPage(
      pillar.pillarPageOptions.pageType === undefined ||
        pillar.pillarPageOptions.pageType === null
        ? true
        : false
    );
  }, [defaultPage]);

  // Get all hotels featured on the page once document is ready so we can filter out duplicates
  useEffect(() => {
    documentReady &&
      getHotelsFeaturedOnPage(
        specialOfferHotelResults,
        mainBlockHotelResults,
        setHotelIdsFeaturedOnPage
      );
  }, [documentReady]);

  // const pillarText = pillar.pillarText
  // // This removes the first sentence from each text block as we need to replace first occurrence later
  // // const pillarTextToChange = pillarText ? (pillarText).map(type => {
  // // 	if(type._type === 'block' && type.style === 'normal') {
  // // 		let isBlockType = false
  // // 		if(!isBlockType) {
  // // 			type.children[0].text = (removeFirstSentence(type.children[0].text))
  // // 			isBlockType = true;
  // // 			return type
  // // 		}
  // // 	}
  // // }) : pillarText;

  // 	const pillarTextToChange = pillarText ? pillarText.find(block => block._type === 'block' && block.style === 'normal').children[0].text : pillarText;

  // console.log(removeFirstSentence(pillarTextToChange))
  // // // Find index of first occurence of a pillar hero text block
  // // const PillarContentTextIndex = pillarText ? (pillarText).findIndex(block => block._type === 'block' && block.style === 'normal') : pillarText;
  // // // Save text block with new paragraph (with first sentence removed)
  // // if(pillarText) {
  // // 	if(pillarText[PillarContentTextIndex] !== pillarTextToChange[0]) {
  // // 		pillarText[PillarContentTextIndex] = pillarTextToChange[0];
  // // 	}
  // // 	else {
  // // 	console.log(pillarText[PillarContentTextIndex])
  // // 	}
  // // }

  // // console.log(pillarTextToChange, PillarContentTextIndex)

  // -> Breadcrumbs
  crumbs.map((crumb) => (crumb.crumbLabel = toSentenceCase(crumb.crumbLabel)));

  /* RENDER PAGE */
  return (
    <>
      <Breadcrumb
        crumbs={crumbs}
        crumbSeparator={<FaAngleRight />}
        crumbLabel={pillar.name}
      />

      <PillarHero data={pillar} />

      <div className="main-content">
        {pillar.pillarPageOptions.pageType !== undefined &&
          pillar.pillarPageOptions.pageType !== null && (
            <MainPillarContent
              specialOffers={specialOffers}
              allHotels={allHotels}
              allPillarPages={pillarPages}
              pillar={pillar}
              specialOfferHotelResults={specialOfferHotelResults}
              mainBlockHotelResults={mainBlockHotelResults}
              isMapOpen={isMapOpen}
              toggleMap={toggleMap}
              placeholderImage={data.placeholderImages.generalPlaceholderImage}
              sponsorsAdBanners={data.sanitySiteSettings.sponsorsAdBanners}
            />
          )}

        {/* Add Portable Text if content added - it removes the first sence above */}
        {pillar.pillarText && (
          <div className="pillar-content">
            <PortableText
              value={pillar.pillarText}
              components={PortableTextComponent}
            />
          </div>
        )}

        {/* Page Content */}
        <PageContentByPageType
          pillar={pillar}
          hotelIdsFeaturedOnPage={hotelIdsFeaturedOnPage}
          placeholderImage={data.placeholderImages.generalPlaceholderImage}
        />
      </div>
    </>
  );
};
export default PillarPage;

/** Attach SEO */
export const Head = ({ data }) => {
  const pillar = data.pillar;

  // Bringing the same logic to get the hotel Lists on the theme page
  const { allHotels } = useContext(RootContext);

  // Empty JsonLd for sending
  let jsonLd = null;

  if (pillar.pillarPageOptions.pageType === "theme") {
    const specialOffers = data.specialOffers.nodes;

    let allFilteredHotels = [];
    let mainBlockHotelResults = [];
    let specialOfferHotelResults = [];

    const typeOfPillarFilter = pillar.pillarFilterOptions;
    if (typeOfPillarFilter === "useSearchTags") {
      allFilteredHotels = getHotelsBySearchTags(allHotels, pillar);
    }

    let pillarResults = getPillarResults(
      allHotels,
      specialOffers,
      allFilteredHotels,
      (mainBlockHotelResults = []),
      (specialOfferHotelResults = [])
    );

    // mainBlockHotelResults = pillarResults.mainBlockHotelResults.slice(0, 30);
    mainBlockHotelResults = pillarResults.mainBlockHotelResults;
    specialOfferHotelResults = pillarResults.specialOfferHotelResults.slice(
      0,
      30
    );

    // Filter out any hotels that have no location as it can't be included in the map
    const hotels = specialOfferHotelResults
      .filter((hotel) => hotel.location && hotel.location.lat)
      .concat(
        mainBlockHotelResults.filter(
          (hotel) => hotel.location && hotel.location.lat
        )
      );

    // Assigning the final data object to jsonLd
    jsonLd = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: pillar?.name || "",
      description: pillar?.seoGroup?.seoMetaDescription || "",
      url: `https://www.goodhotelguide.com/${
        pillar?.parentPage?.slug?.current
          ? `${pillar?.parentPage?.slug?.current}/`
          : ""
      }${pillar?.slug?.current}`,
      image:
        pillar?.pillarHero?.heroImage?.asset?.gatsbyImageData?.images?.fallback
          ?.src || "",
      numberOfItems: hotels?.length,
      itemListOrder: "https://schema.org/ItemListUnordered",
      itemListElement: hotels?.map((hotel, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `https://www.goodhotelguide.com/review/${hotel?.slug?.current}`,
        name: hotel?.name,
        image:
          hotel?.reviewTextAndMedia?.homepageFeaturedImage?.asset
            ?.gatsbyImageData?.images?.fallback?.src || "",
        description:
          hotel?.reviewTextAndMedia?.summaryContent?.[0]?.children?.[0]?.text ||
          "",
        item: {
          "@type": "Hotel",
          name: hotel?.name,
          address: {
            "@type": "PostalAddress",
            streetAddress: hotel?.addressGroup?.street || "",
            addressLocality:
              hotel?.addressGroup?.town || hotel?.addressGroup?.village || "",
            addressRegion: hotel?.addressGroup?.county || "",
            postalCode: hotel?.addressGroup?.postCode || "",
            addressCountry: hotel?.addressGroup?.country || "",
          },
          geo: {
            "@type": "GeoCoordinates",
            latitude: hotel?.location?.lat,
            longitude: hotel?.location?.lng,
          },
          telephone: hotel?.contactGroup?.telephone || "",
          url: hotel?.contactGroup?.websiteUrl || "",
          amenityFeature: [
            ...(hotel?.hotelInformation?.searchTags || []).map((tag) => ({
              "@type": "LocationFeatureSpecification",
              name: tag?.label,
              value: true,
            })),
            ...(hotel?.searchTagSummaries?.searchTagSummaries || []).map(
              (tag) => ({
                "@type": "LocationFeatureSpecification",
                name: tag?.tag?.[0]?.value || "",
                value: true,
              })
            ),
          ],
          image: [
            hotel?.reviewTextAndMedia?.homepageFeaturedImage?.asset
              ?.gatsbyImageData?.images?.fallback?.src,
            ...(hotel.reviewTextAndMedia?.images || []).map(
              (img) => img.asset?.gatsbyImageData?.images?.fallback?.src
            ),
          ].filter(Boolean),
        },
      })),
    };
  }

  return (
    <>
      <SEO
        title={
          pillar.seoGroup && pillar.seoGroup.seoMetaTitle
            ? pillar.seoGroup.seoMetaTitle
            : `${pillar.name} - Good Hotel Guide`
        }
        description={
          pillar.seoGroup &&
          pillar.seoGroup.seoMetaDescription &&
          pillar.seoGroup.seoMetaDescription
        }
        key={
          pillar.seoGroup && pillar.seoGroup.seoMetaTitle
            ? pillar.seoGroup.seoMetaTitle
            : `${pillar.name} - Good Hotel Guide`
        }
      />
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : (
        ""
      )}
    </>
  );
};

/* GRAPHQL QUERY */
export const query = graphql`
  query ($slug: String!, $parentSlug: String) {
    pillar: sanityPillar(
      slug: { current: { eq: $slug } }
      parentPage: { slug: { current: { eq: $parentSlug } } }
    ) {
      ...PillarFragment
    }

    # Get any special offers that have an id equal to hotel id - we add the hotel id in gatsby-node so we can access as a variable
    specialOffers: allSanitySpecialOffer(filter: { enabled: { eq: true } }) {
      nodes {
        ...SpecialOfferFragment
      }
    }

    placeholderImages: sanityPlaceholderImages {
      generalPlaceholderImage: generalPlaceholder {
        asset {
          gatsbyImageData(width: 800, placeholder: BLURRED)
        }
      }
    }

    sanitySiteSettings {
      sponsorsAdBanners {
        _key
        sponsorName
        alt
        externalLink
        mobileImage {
          asset {
            gatsbyImageData(placeholder: DOMINANT_COLOR, width: 600)
          }
        }
        desktopImage {
          asset {
            gatsbyImageData(placeholder: DOMINANT_COLOR, width: 1200)
          }
        }
      }
    }
  }
`;
